"use client";

import React, { memo } from "react";
import { cn } from "utils";
import NextImage from "@/src/components/NextImage";

type ReportSymbolProps = {
  assetIcon: string;
  symbol: string;
  className?: string;
  imgClass?: string;
  textClass?: string;
};

export const ReportSymbol: React.FC<ReportSymbolProps> = memo(
  ({ assetIcon, symbol, className, imgClass, textClass }) => {
    return (
      <div className={cn("flex items-center", className)}>
        {assetIcon && (
          <NextImage
            src={assetIcon}
            alt={symbol}
            width={24}
            height={24}
            className={cn(
              "w-8 h-8 md:w-6 md:h-6 rounded-full border-border_solid border mr-1",
              imgClass,
            )}
          />
        )}
        <span
          className={cn(
            "body_medium_l md:body_medium_xl text-content_primary",
            textClass,
          )}
        >
          {symbol}
        </span>
      </div>
    );
  },
);

ReportSymbol.displayName = "ReportSymbol";
